import { useState, useEffect } from 'react';
import { Vif } from 'common/visualizations/vif';
import { getAutocompleteValuesForColumn } from '../helpers/autocompleteHelpers';

/**
 * Custom hook to fetch autocomplete values for a specific column
 * Handles race conditions by ignoring stale responses
 * Automatically applies any filters present in the VIF to limit autocomplete suggestions
 * @param vif - The VIF object containing dataset information
 * @param columnName - The name of the column to get autocomplete values for
 * @returns Array of autocomplete suggestion strings
 */
export const useAutocompleteValues = (vif: Vif | null | undefined, columnName: string): string[] => {
  const [values, setValues] = useState<string[]>([]);

  useEffect(() => {
    let ignore = false;

    if (columnName && vif) {
      getAutocompleteValuesForColumn(vif, columnName)
        .then((result) => !ignore && setValues(result))
        .catch((error) => {
          if (!ignore) {
            console.error('Error fetching autocomplete values:', error);
            setValues([]);
          }
        });
    } else {
      setValues([]);
    }

    return () => {
      ignore = true;
    };
  }, [vif, columnName]);

  return values;
};
